import { getEnv } from 'src/helpers/common'

/**
 * Заменяет все страницы на страницу технические работы
 */
export const TECH_WORKS = false

export const SEC_INTERVAL_CHECK_TOKEN = 2000

export const DELAY_IN_SEC_BEFORE_ACCESS_EXPIRE = 15000

export const KDVID_FRONT_INDIVIDUAL_URL = getEnv('VITE_REACT_APP_KDVID_FRONT_INDIVIDUAL_URL')
